/**
 * @class
 * @classdesc Утилита для рассчёта кривых Безье
 * @abstract
 * @memberof module:math
 */
class Bezier {

    /** @ignore */
    static getBasis(i, n, t) {
        function f(n) {
            return (n <= 1) ? 1 : n * f(n - 1);
        }
        return (f(n) / (f(i) * f(n - i))) * Math.pow(t, i) * Math.pow(1 - t, n - i);
    }

    /**
     * Рассчет кривой безье
     * @param {Object[]} points массив точек {x:number, y:number}
     * @param {Number} [step=0.1] шаг рассчета (от >0 до 1) Чем меньше шаг, тем чаще просчитываются точки на кривой.
     * @returns {Object[]} массив точек на кривой {x:number, y:number}
     */
    static getCurve(points, step = 0.1) {
        var res = [];
        step = step / points.length;
        for (var t = 0.0; t < 1 + step; t += step) {
            if (t > 1) t = 1;
            var ind = res.length;
            res[ind] = {x: 0, y: 0};
            for (var i = 0; i < points.length; i++) {
                var b = Bezier.getBasis(i, points.length - 1, t);
                res[ind].x += points[i].x * b;
                res[ind].y += points[i].y * b;
            }
        }
        return res;
    }
}

export { Bezier };